import styled from 'styled-components';
import Image from '@stencil/image';

export interface SpacesItemListWrapperProps {
  width: number;
  isPrivateSpace?: boolean;
}

export interface SpacesItemListContainerProps {
  isPrivateRightBtnEnabled?: boolean;
  isSharedLeftBtnEnabled?: boolean;
}

export interface SliderArrowRightProps {
  isPrivateSpace?: boolean;
}

export interface SliderArrowLeftProps {
  isPrivateSpace?: boolean;
}

export const HomeStaySpacesWrapper = styled.section(
  props => `
  max-width: 120rem;
  margin: 0 auto;
  padding: 3.2rem 0 1rem;
  width: 100%;
  `,
);

export const HomeStaySpacesInnerWrapper = styled.div(
  props => `
  background: ${props.theme.colors.goWhite.base};
  border-radius: 12px;
    `,
);

export const HomeStaySpacesHeaderWrapper = styled.div(
  props => `
    padding: 2.4rem;
    border-bottom: 1px solid #E1E7EE;
    .headerText {
              font-weight: 600;
        font-size: 22px;
        color: #000000;
        margin-bottom: 0.4rem;
    }

    .descText {
        display: flex;
        align-items:center;
        font-size: 16px;

        color: #000000;
    }

    .roomText {
        margin-right: 0.4rem;
    }

    .moreRoomTypes {
              font-weight: 600;
        font-size: 16px;

        color: #008CFF;
        margin-left: 0.8rem;
    }
    `,
);

export const HomeStaySpacesContentWrapper = styled.div(
  props => `
      padding: 2.4rem;
      display: flex;
      overflow: hidden !important;
    `,
);

export const HomeStaySpacesCardWrapper = styled.div(
  props => `
        background: ${props.theme.colors.goWhite.base};
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        overflow:hidden;
        min-width: 20.5rem !important;
        width: 20.5rem !important;
        height: 25rem !important;
        margin: 0.5rem 0.6rem 0.5rem 0.2rem;
        `,
);

export const HomeStaySpacesImgWrapper = styled.div(
  props => `
          width: 100%;
          height: 14rem;
          position: relative;
          `,
);

export const HomeStaySpacesImg = styled.img(
  props => `
            width: 100%;
            height: 14rem;
            object-fit: cover;
            `,
);

export const SpacesItemListWrapper = styled.div<SpacesItemListWrapperProps>(
  props => `
  width: ${props.width}rem;
  position: relative;
    .spaceItemHeader {
          font-weight: 600;
      font-size: 16px;
      color: #000000;
      ${!props?.isPrivateSpace ? `margin-left: 2.4rem;` : ''}
    }
  `,
);

export const HomeStaySpacesItemListWrapper = styled.div(
  props => `
    display: flex;
  `,
);

export const LineDivider = styled.div(
  props => `
    border-right: 1px solid #e5edf6;
  `,
);

export const SpacesItemListContainer = styled.section<SpacesItemListContainerProps>(
  props => `
    overflow: hidden;
    &.privateSpaceList {
      margin: 1.6rem ${props?.isPrivateRightBtnEnabled ? 4.4 : 2.4}rem 0 0;
    }
    &.publicSpaceList {
      margin: 1.6rem 0 0 ${props?.isSharedLeftBtnEnabled ? 4.4 : 2.4}rem;
    }
  `,
);

export const SpacesItemList = styled.div(
  props => `
    border-radius: 8px;
    width: 100%;
    display: flex;
    `,
);

export const HomeStaySpacesImgCountWrapper = styled.div(
  props => `
    display: flex;
    position: absolute;
    right: 2rem;
    bottom: 0.8rem;
    align-items:center;
    padding: 0.6rem;
    background: rgba(0, 0, 0, 0.65);
    border-radius: 4px;
    color: #FFFFFF;
    .countImg {
        width: 1.2rem;
        height: 1.2rem;
        margin-right: 0.5rem;
    }
  `,
);

export const HomeStaySpacesCardContentWrapper = styled.div(
  props => `
          padding: 1.2rem;

          .bedroomTextWrapper {
            display: flex;
            align-items:center;
          }

          .bedroomText {
            font-weight: 900;
            font-size: 16px;
            color: #4A4A4A;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .areaText {
            margin-left: 0.4rem;
                      font-size: 12px;
            color: #747474;
          }

          .maxGuest {
                      font-size: 12px;
            color: #9B9B9B;
            min-height: 15px;
          }

          .featureText {
            margin-top: 0.9rem;
            font-weight: 400;
            font-size: 14px;
            color: #4A4A4A;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
          }
          `,
);

export const RoomTypeModalHeaderWrapper = styled.div(
  props => `
              padding: 2.4rem;
              display: flex;
              align-items:center;
              justify-content:space-between;
              border-bottom: 1px solid #C7C7C7;
              .modalHeaderText {
                              font-weight: 600;
                font-size: 22px;
                color: #000000;
              }
              `,
);

export const RoomTypeModalContentWrapper = styled.div(
  props => `
                padding: 0 2.4rem 2.4rem;
                
                `,
);

export const RoomTypeModalCtaBtn = styled.span(
  props => `
    background: ${props.theme.colors.goBrandOrange.base};
    box-shadow: 0px 3px 4px rgb(0 0 0 / 20%);
    border-radius: 12px;
    text-align:center;
      font-weight: 900;
    font-size: 16px;
    text-align: center;
    letter-spacing: 0.228571px;
    text-transform: uppercase;
    color: ${props.theme.colors.goWhite.base};
    padding: 1.4rem 0;
    width: 30rem;
    display: block;
    margin: auto;
                  `,
);

export const RoomTypeModalList = styled.ul(
  props => `
      padding-bottom: 2rem;
  `,
);

export const RoomTypeModalListItem = styled.li(
  props => `
      display: flex;
      align-items:center;
      padding: 1.4rem 0;
      border-bottom: 1px solid #C7C7C7;
      cursor: pointer;
      
      label {
        margin-left: 1.8rem;
        font-size: 16px;
        color: #000000;
        cursor: inherit;
      }
      input {
        cursor: inherit; 
      }
    `,
);

export const ImgStyles = styled(Image)(
  props => `
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.5rem;
`,
);

export const SliderArrowRight = styled.button<SliderArrowRightProps>(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: ${props.isPrivateSpace ? '2.5rem' : '-2rem'};
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);

export const SliderArrowLeft = styled.button<SliderArrowLeftProps>(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: ${props.isPrivateSpace ? '-2rem' : '2rem'};
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);
